import { Maximize, Minimize } from 'lucide-react'
import { ComponentProps, useState } from 'react'

import { IconActionButton } from '@/components/common/buttons/icon-action-button'
import { SheetContent } from '@/components/ui/sheet'
import { cn } from '@/lib/utils'

interface Props extends ComponentProps<typeof SheetContent> {
  collapsedClassName?: string
  expandedClassName?: string
}

export function ExpandableSheetContent({
  collapsedClassName = 'sm:max-w-xl',
  expandedClassName = 'sm:max-w-4xl',
  className,
  children,
  ...props
}: Props) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <SheetContent
      className={cn(
        'w-full overflow-y-auto',
        isExpanded ? expandedClassName : collapsedClassName,
        className,
      )}
      {...props}
    >
      <IconActionButton
        icon={isExpanded ? Minimize : Maximize}
        tooltip={isExpanded ? 'Reduzir' : 'Expandir'}
        variant="ghost"
        size="sm"
        className="absolute right-12 top-4"
        onClick={() => setIsExpanded((value) => !value)}
      />
      {children}
    </SheetContent>
  )
}
